(function () {'use strict';}());
angular.module("elidb").directive('crazyEgg', function($window, $document,$timeout, ELIService) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/crazy-egg.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;
        $scope.currentPageName = null;
        $scope.$watch("currentPage",onPageChange);
        $scope.$watch("eggState", onEggChange);

        function onEggChange(value) {
          if(!(value || value === 0)) return;
          if(!window.$) return setTimeout(function(){ onEggChange(value); }, 500);
          var jq = $;
          var trackingExists = window.CE2 ? true : false;

          trace("on egg change: " + $scope.eggState);

          switch($scope.currentPage) {
            case 0:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Landing Page";
            break;
            case 1:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Search Results Page";
            break;
            case 3:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Result Detail Page";
            break;
            case 4:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Profile Page" + ($scope.eggState ? (" " + $scope.eggState) : "");
            break;
            default:
          }

          $scope.varText = "var CE_SNAPSHOT_NAME = \""+$scope.currentPageName+"\"";
          window.CE_SNAPSHOT_NAME = $scope.currentPageName;
        }

        function onPageChange(value) {
          if(!(value || value === 0)) return;
          var jq = $;
          if(!window.$) return setTimeout(function(){ onPageChange(value); }, 500);
          var trackingExists = window.CE2 ? true : false;

          trace("on page change");

          switch(value) {
            case 0:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Landing Page";
            break;
            case 1:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Search Results Page";
            break;
            case 3:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Result Detail Page";
            break;
            case 4:
              $scope.currentPageName = "Exceptional Lives Resource Database "+__STATE__+" Profile Page" + ($scope.eggState ? (" " + $scope.eggState) : "");
            break;
            default:
          }

          $scope.varText = "var CE_SNAPSHOT_NAME = \""+$scope.currentPageName+"\"";
          window.CE_SNAPSHOT_NAME = $scope.currentPageName;

         // ELIService.gtag($window.location.hash, __LANG__, __STATE__);

          if(trackingExists) return;
          
          $timeout(function(){
            jq("body").append('<script id="egg-tracking-script" type="text/javascript" src="//script.crazyegg.com/pages/scripts/0075/5663.js" async="async"></script>');
          },100);
        }


      }  
    };
  });